import '../../editor/settings_manager.js';
import '../../editor/i18n.js';
import { UIController } from '@hcie/ui-components';
import { initUICoordinator } from '../../editor/ui-coordinator';
import '../../editor/settings_ui.js';
import '../../editor/menu_connections.js';
import { initPWA } from './pwa-handler';

/**
 * Bootstrap the application.
 * Ensures that globals are set and the UI logic is initialized in the correct order.
 */
async function bootstrap() {
    console.log("[Main] Starting application bootstrap...");
    
    // 0. Update UI Version Label from package.json (via Vite define)
    const versionLabel = document.getElementById('appVersionLabel');
    if (versionLabel && typeof __APP_VERSION__ !== 'undefined') {
        versionLabel.textContent = `HC Image Editor v${__APP_VERSION__} Beta - Beta program, do not use on important files`;
    }

    // 1. Initialize the UI (attaches events, sets up panels)
    const ui = new UIController();
    await ui.init();

    // 2. Initialize the coordinator (sets up g.canvas, EventBus subscriptions, and global functions)
    // IMPORTANT: This must run AFTER UIController.init() to ensure it can override 
    // any legacy window exposures with modularized ones.
    initUICoordinator();
    
    // 3. Setup PWA features
    initPWA();
    
    console.log("[Main] Bootstrap complete.");
}

bootstrap().catch(err => {
    console.error("[Main] Critical bootstrap failure:", err);
});
